'use client';
import styles from './styles.module.scss';
import { useState } from 'react';
import { Checkbox } from 'pretty-checkbox-react';

const Form = () => {
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState(false);
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        reason: '',
        phone: '',
        email: '',
        message: '',
        company: '',
        checkboxes: {
            ymca: false,
            jcc: false,
            boysAndGirlsClub: false,
            communityCenter: false,
            parksAndRecreation: false,
            other: false,
        },
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            setFormData({
                ...formData,
                checkboxes: {
                    ...formData.checkboxes,
                    [name]: checked,
                },
            });
        } else {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(false);
        try {
            const response = await fetch('/api/contact_form', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                throw new Error('Failed to submit form');
            }

            const data = await response.json();
            setFormData({
                firstName: '',
                lastName: '',
                phone: '',
                email: '',
                company: '',
                checkboxes: {
                    memberManagement: false,
                    programLeagueManagement: false,
                    financeManagement: false,
                    childCare: false,
                    marketingEngagement: false,
                    facilityManagement: false,
                    ymca: false,
                    jcc: false,
                    boysAndGirlsClub: false,
                    communityCenter: false,
                    parksAndRecreation: false,
                    other: false,
                }
            });
            setLoading(false);
            setError(false);
            setSubmitted(true);
        } catch (error) {
            console.error(error);
            setLoading(false);
            setError(true);
            setSubmitted(false);

        }
    };

    const renderCtaOrSuccessMessage = () => {
        if (!submitted) {
            return (
                <div>
                    <button disabled={loading} className='submit'>
                        Submit
                    </button>
                </div>
            );
        } else {
            return (
                <div>
                    <div className={styles.contactForm__success}>
                        You have Successfully Submitted Your Request
                    </div>
                </div>
            );
        }
    };

    return (
        <form className={styles.contactForm} onSubmit={handleSubmit}>
            <div>
                <fieldset className='fieldset'>
                    <label className="label">First Name</label>
                    <input
                        type="text"
                        name="firstName"
                        placeholder='First Name'
                        className={`input ${error ? 'input_error' : ''}`}
                        onChange={handleChange}
                        required
                    />
                </fieldset>
                <fieldset className='fieldset'>
                    <label className="label">Email</label>
                    <input
                        type="email"
                        name="email"
                        placeholder='Email'
                        className={`input ${error ? 'input_error' : ''}`}
                        onChange={handleChange}
                        required
                    />
                </fieldset>
            </div>
            <div>
                <fieldset className='fieldset'>
                    <label className="label">Last Name</label>
                    <input
                        type="text"
                        name="lastName"
                        placeholder='Last Name'
                        className={`input ${error ? 'input_error' : ''}`}
                        onChange={handleChange}
                        required
                    />
                </fieldset>
                <fieldset className='fieldset'>
                    <label className="label">Phone</label>
                    <input
                        type="tel"
                        name="phone"
                        placeholder='Phone'
                        className={`input ${error ? 'input_error' : ''}`}
                        onChange={handleChange}
                        required
                    />
                </fieldset>
            </div>
            <div>
                <fieldset className='fieldset'>
                    <label className="label">Organization</label>
                    <input
                        type="tel"
                        name="company"
                        placeholder='Organization'
                        className={`input ${error ? 'input_error' : ''}`}
                        onChange={handleChange}
                        required
                    />
                </fieldset>
            </div>
            <div className={styles.contactForm__checkList}>
                <label className={styles.contactForm__label}>I Am Representing:</label>
                <Checkbox
                    name="ymca"
                    checked={formData.checkboxes.ymca}
                    onChange={handleChange}
                >
                    YMCA
                </Checkbox>
                <Checkbox
                    name="jcc"
                    checked={formData.checkboxes.jcc}
                    onChange={handleChange}
                >
                    JCC
                </Checkbox>
                <Checkbox
                    name="boysAndGirlsClub"
                    checked={formData.checkboxes.boysAndGirlsClub}
                    onChange={handleChange}
                >
                    Boys and Girls Club
                </Checkbox>
                <Checkbox
                    name="communityCenter"
                    checked={formData.checkboxes.communityCenter}
                    onChange={handleChange}
                >
                    Community Center
                </Checkbox>
                <Checkbox
                    name="parksAndRecreation"
                    checked={formData.checkboxes.parksAndRecreation}
                    onChange={handleChange}
                >
                    Parks and Recreation
                </Checkbox>
                <Checkbox
                    name="other"
                    checked={formData.checkboxes.other}
                    onChange={handleChange}
                >
                    Other
                </Checkbox>
            </div>
            <fieldset className={`fieldset ${styles.contactForm__textBox}`}>
                <label className="label">Would you like to tell us anything specific about your needs?</label>
                <textarea
                    name="additionalInfo"
                    className={`${error ? 'input_error' : ''}`}
                    onChange={handleChange}
                ></textarea>
            </fieldset>
            {renderCtaOrSuccessMessage()}
        </form>
    );
};

export default Form;
